<ui-section title="Edit name format" [collapsable]="true">
	<div section-content class="flex flex-col">
		<div>
			<!-- Nav -->
			<atomic-button-group
				orientation="row"
				type="tab"
				[options]="tabs"
				[(ngModel)]="selectedTab"
				class="flex-1"
			></atomic-button-group>
		</div>
		<!-- alert  -->
		<div class="flex items-center justify-center my-4">
			<app-pill
				[leftIcon]="ICON.EXCLAMATION"
				size="large"
				mode="secondary"
				size="small"
				textClass="text-base text-left"
			>
				Names of clients, mortgagors, other party, associated contacts, signing
				officers, <br />
				consenting spouses, guarantors will all follow these selections
			</app-pill>
		</div>

		<ng-container *ngIf="selectedTab === tabOptions.INDIVIDUAL">
			<!-- settings -->
			<div class="grid grid-cols-1 gap-2 mb-2">
				<div class="w-fit">
					<app-radio-group
						label="First name"
						[items]="caseTypeOptions"
						type="compact"
						[ngModel]="nameFormattingSettings.individual.firstName.caseStyle"
						(ngModelChange)="setFirstNameCaseType($event)"
					></app-radio-group>
				</div>

				<div class="w-fit">
					<app-radio-group
						label="Middle name"
						[items]="caseTypeOptions"
						type="compact"
						[ngModel]="nameFormattingSettings.individual.middleNames.caseStyle"
						(ngModelChange)="setMiddleNamesCaseType($event)"
					></app-radio-group>
				</div>

				<div class="w-fit">
					<app-radio-group
						label="Last name"
						[items]="caseTypeOptions"
						type="compact"
						[ngModel]="nameFormattingSettings.individual.lastName.caseStyle"
						(ngModelChange)="setLastNameCaseType($event)"
					></app-radio-group>
				</div>
			</div>

			<!-- dropdown -->
			<div class="mt-2">
				<app-dropdown
					[itemGroups]="[{ items: parsedNameFormattingOptions }]"
					[value]="selectedFormat"
					(onSelect)="onSelectFormat($event)"
				></app-dropdown>
			</div>
		</ng-container>

		<ng-container *ngIf="selectedTab === tabOptions.COMPANY">
			<div class="flex">
				<app-radio-group
					class="mt-2"
					label="Full name"
					[items]="caseTypeOptions"
					type="compact"
					[ngModel]="nameFormattingSettings.company.caseStyle"
					(ngModelChange)="setBusinessNameCaseType($event)"
				></app-radio-group>
			</div>
		</ng-container>
	</div>
</ui-section>
